import React from 'react';
import './Name.css'; // Make sure to create this CSS file
import RegisterButton from '../Register_Button/RegisterButton';
import {Link} from "react-router-dom"
import { Menu } from 'lucide-react';
import {useEffect} from "react";
import HeaderAnimation from '../../components/Header/HeaderAnimation';

const Name = () => {
  useEffect(()=> {
    window.addEventListener('click', (event) => {
      if(!document.getElementById('ham')?.contains(event.target)) {
        document.getElementById('mob-ul')?.classList.remove('dropdown-custom')
      }
    })
  }, [])
  return (
    
<>
<HeaderAnimation/>
<nav id="pc-nav">
        <img src="" alt="" width="100"  />
        <ul>
          <li><a href="#event-heading">Events</a></li>
          <li><a href="#coordinators-heading">Coordinators</a></li>
          <li><Link to="/team">Team</Link></li>
          <li><a href="#faq-main">FAQ</a></li>
          <li><a href="#footer-main">Contact</a></li>
        </ul>
      </nav>
      <div id="mob-nav">
        <Menu id="ham" onClick={
          () => {
            if(document.getElementsByClassName('dropdown-custom').length==0)
            document.getElementById('mob-ul')?.classList.add('dropdown-custom')
          else
                    document.getElementById('mob-ul')?.classList.remove('dropdown-custom')
              }} />
        <div id="mob-ul">
          <ul>
            <li><a href="#event-heading">Events</a></li>
            <li><a href="#coordinators-heading">Coordinators</a></li>
            <li><Link to="/team">Team</Link></li>
            <li><a href="#faq-main">FAQ</a></li>
            <li><a href="#footer-main">Contact</a></li>
          </ul>
        </div>

      </div>
<section>
      <div className="hero-container">
       <img src="https://www.rajalakshmi.org/techathon/assets/img/REC.png" alt="" />
        <h1 className="dept">Department of Computer Science and Engineering<br/> Presents</h1>
        <br />
        <h2 className="hero glitch layers" data-text="TECH-A-THON"><span>TECH
            <span style={{'color':'yellow'}}>-A-</span>
            THON</span></h2>
            <h2>2K24</h2>   
            <br></br>
            {/* <RegisterButton/> */}
            <div>
              <a><button className="register-btn" disabled>REGISTRATION CLOSED</button></a>
            </div>
            <br />
            </div>

            <section className="about-container">
              <div className="about-content">
              <h1 style={{'color':'yellow','letterSpacing':'5px'}}>ABOUT TECH-A-THON</h1>
                <p>Tech-A-Thon is an Intra–departmental Technical Festival organized by the department of CSE. It was initiated in the year 2016 with an aim to encourage our department students to improvise their skill set in programming and accord them 
            a chance to haul up the spotlight shine over them.</p>
              </div>
              <div className="quotes-div">
                <h1 className="quotes">
                  <span>Do<hide>n't</hide></span>
                  <span><hide>
                    Qu</hide>it</span>
                </h1>
              </div>
      </section>
    </section>
</>
  );
};

export default Name;
